import type { ContractStatus } from '../../../contracts/api';

/**
 * Mirrors the manual rows of `apps/api` `CONTRACT_TRANSITIONS`
 * (`contract-state-machine.ts`) for UI-only button disabling
 * (`contracts/spec.md` → "Máquina de estados"). `EXPIRED` has no manual
 * transition: it only happens through the scheduled job. This is a display
 * hint, not enforcement — the API rejects an invalid transition with
 * `CONTRACT_INVALID_TRANSITION` regardless of what this table says.
 */
const MANUAL_TRANSITIONS: ReadonlyArray<{ from: ContractStatus; to: ContractStatus }> = [
  { from: 'DRAFT', to: 'ACTIVE' },
  { from: 'PAUSED', to: 'ACTIVE' },
  { from: 'ACTIVE', to: 'PAUSED' },
  { from: 'ACTIVE', to: 'TERMINATED' },
  { from: 'PAUSED', to: 'TERMINATED' },
];

export function canTransition(from: ContractStatus, to: ContractStatus): boolean {
  return MANUAL_TRANSITIONS.some((row) => row.from === from && row.to === to);
}
